<script setup>
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog'
import { AlertTriangle } from 'lucide-vue-next'

defineProps({
  open: { type: Boolean, default: false },
  fileName: { type: String, default: '' },
  reason: { type: String, default: 'missing-prj' }
})

const emit = defineEmits(['confirm', 'cancel'])
</script>

<template>
  <Dialog :open="open" @update:open="(v) => { if (!v) emit('cancel') }">
    <DialogContent class="max-w-md">
      <DialogHeader>
        <DialogTitle class="flex items-center space-x-2">
          <AlertTriangle class="w-5 h-5 text-amber-500" />
          <span>{{ reason === 'missing-prj' ? 'Missing projection file' : 'Unsupported projection' }}</span>
        </DialogTitle>
        <DialogDescription>
          <span class="font-mono">{{ fileName }}</span>
          <template v-if="reason === 'missing-prj'">
            has no <span class="font-mono">.prj</span> file and its coordinates look projected (not latitude/longitude).
          </template>
          <template v-else-if="reason === 'bad-prj'">
            has a <span class="font-mono">.prj</span> file we couldn't read, and its coordinates look projected (not latitude/longitude).
          </template>
          <template v-else>
            uses a projected coordinate system (not latitude/longitude). Re-export it as WGS84 (EPSG:4326).
          </template>
          Features may appear in the wrong location on the map.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter class="gap-2">
        <Button variant="outline" @click="emit('cancel')">Skip file</Button>
        <Button @click="emit('confirm')">Load as WGS84 anyway</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
